import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DriverPenaltyFilterEntity } from '../../domain/entities/DriverPenaltyFilterEntity'

export class DriverPenaltyFilterModel extends DriverPenaltyFilterEntity {
  driverId?: number
  regionId?: number

  constructor(dataDto: DriverPenaltyFilterEntity) {
    super()
    mapEntityProperties<DriverPenaltyFilterModel>(this, dataDto, {
      exclude: ['driver', 'region'],
      map: {
        driverId: dataDto.driver?.id,
        regionId: dataDto.region?.id
      }
    })
  }
}
